/**
 * The job titles offered as suggestions.
 *
 * Shared by Add Candidate and the Employment details section of Add & Edit
 * Staff, because a candidate's job title becomes that staff member's job title
 * at transfer — two lists would offer different spellings of the same job and
 * the transfer would look like a change.
 *
 * Suggestions, not a closed set: both places render this through a <datalist>,
 * so a home with a title of its own can still type it. There is deliberately no
 * table of job titles to maintain — see the note on job_role_type in
 * api/models/userProfileSections.js for what happened to the managed-list
 * version of this idea.
 */
export const JOB_TITLES = [
  'Care Assistant',
  'Senior Care Assistant',
  'Registered Nurse',
  'Care Home Manager',
  'Deputy Manager',
  'Administrator',
  'Domestic Assistant',
  'Kitchen Assistant',
  'Activities Coordinator',
];

export default JOB_TITLES;
